import { FormFieldNamesEnum } from './formFieldNamesEnum'

export const FIELDS_REQUIRED_FOR_SUBMISSION = [
  FormFieldNamesEnum.Email,
  FormFieldNamesEnum.PPMerchantId
]

export const validators: { [key in FormFieldNamesEnum]?: (arg0: string) => string | null } = {
  [FormFieldNamesEnum.Email]: val => {
    if (!val) { return 'Required' }
    return null
  },
  [FormFieldNamesEnum.PPMerchantId]: val => {
    if (!val) { return 'Required' }
    return null
  }
}
